import React from "react";
import "./style.css";

const LoadingAnimation = ({ fullScreen = false, compact = false }) => {
  const wrapperClasses = ["loading-animation-wrapper"];
  const loaderClasses = ["loader"];
  if (fullScreen) wrapperClasses.push("fullscreen");
  if (compact) {
    wrapperClasses.push("compact");
    loaderClasses.push("compact");
  }
  return (
    <div className={wrapperClasses.join(" ")}>
      <div className={loaderClasses.join(" ")} />
    </div>
  );
};

export default LoadingAnimation;
